import React, { Component } from 'react';
import { Text, TextInput, TouchableOpacity } from 'react-native';

import { Checkbox } from '@material-ui/core';
import { styles } from './styles';
import {
  SIGNUPTO,
  SIGN_UP,
  FULL_NAME_REQUIRED,
  EMAIL_REQUIRED,
  INVALID_EMAIL,
  PASSWORD_REQUIRED,
  GO,
  TERMS_CONDITIONS,
  FULL_NAME_LENGTH_ERROR,
  NMLS_NUMBER_REQUIRED,
  SELECT_COMPANY_NAME,
} from '../../../shared/constants/Constants';
import { Button } from '../../../components/atoms/Button';
import { DropDown } from '../../../components/atoms/DropDown';
import * as utility from '../../../shared/services/Utility';
import {
  GREY_COLOR,
  SECONDARY_DARK_COLOR,
  PRIMARY_COLOR,
} from '../../../shared/constants/ColorConstants';
import LoadingModal from '../../../components/atoms/LoadingModal';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import { TutorialSlider } from '../../../components';
// import firebase from '../../../shared/services/firebase';

const { ROUTE_CONSTANTS } = require(`../../../shared/constants/Route`);

class SingUpScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyList: {},
      checked: false,
      values: {
        companyId: '',
        fullName: '',
        nmlsNumber: '',
        emailId: '',
        password: '',
      },
      errors: {
        fullNameError: '',
        companyNameError: '',
        nmlsNumberError: '',
        emailIdError: '',
        passwordError: '',
      },
      checkedError: '',
      signupProcessing: false,
      showLogin: this.props.showLogin,
    };
    this.alreadyLogin = false;
    this.companyRef = React.createRef();
    this.emailRef = React.createRef();
    this.passwordRef = React.createRef();
    // this.history = useHistory();
  }

  componentDidMount() {
    this.props.fetchCompanies((message) => {
      this.props.enqueueSnackbar(message, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    });
  }

  setCompanyId(id) {
    const { values, errors } = this.state;
    values['companyId'] = id;
    const resetErrors = {
      ...errors,
      companyNameError: '',
    };
    this.setState({ values, errors: resetErrors });
  }

  validate = (value, key, allErrors) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'fullName': {
        if (!value) {
          return (allErrors.fullNameError = FULL_NAME_REQUIRED);
        }
        if (value.trim().length < 2) {
          return (allErrors.fullNameError = FULL_NAME_LENGTH_ERROR);
        }
        return (allErrors.fullNameError = '');
      }
      case 'companyId': {
        if (!value) {
          return (allErrors.companyNameError = SELECT_COMPANY_NAME);
        }
        return (allErrors.companyNameError = '');
      }
      case 'nmlsNumber': {
        if (!value) {
          return (allErrors.nmlsNumberError = NMLS_NUMBER_REQUIRED);
        }
        return (allErrors.nmlsNumberError = '');
      }
      case 'emailId': {
        if (!value) {
          return (allErrors.emailIdError = EMAIL_REQUIRED);
        }
        if (!utility.validEmail(value)) {
          return (allErrors.emailIdError = INVALID_EMAIL);
        }
        return (allErrors.emailIdError = '');
      }
      case 'password': {
        if (!value) {
          return (allErrors.passwordError = PASSWORD_REQUIRED);
        }
        return (allErrors.passwordError = '');
      }
    }
  };

  onPressSignupBtn() {
    const {
      fullName,
      companyId,
      emailId,
      nmlsNumber,
      password,
    } = this.state.values;
    const signUpBody = {
      fullName: fullName.trim(),
      companyId: companyId,
      emailId: emailId.trim(),
      nmlsNumber: nmlsNumber.trim(),
      password,
    };
    const arr = [
      { fullName },
      { emailId },
      { password },
      { nmlsNumber },
      { companyId },
    ];
    const allErrors = { ...this.state.errors };
    arr.forEach((obj) =>
      this.validate(Object.values(obj)[0], Object.keys(obj)[0], allErrors),
    );
    this.setState({ errors: allErrors });
    const res = Object.keys(allErrors).filter((key) => !!allErrors[key]);
    if (res.length === 0) {
      if (!this.state.checked) {
        return this.setState({ checkedError: TERMS_CONDITIONS });
      }

      this.props.dispatchSignUpRequest(signUpBody, (message, type) => {
        this.props.enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
        type === 'success' && this.props.history.replace(ROUTE_CONSTANTS.LOGIN);
      });
    }
    // if (signUpBody.fullName === "") {
    //   return alert(Constants.FULL_NAME_REQUIRED);
    // }
    // if (signUpBody.companyId === "") {
    //   return alert(Constants.SELECT_COMPANY_NAME);
    // }
    // if (signUpBody.nmlsNumber === "") {
    //   return alert(Constants.NMLS_NUMBER_REQUIRED);
    // }
    // if (!utility.validNumber(signUpBody.nmlsNumber)) {
    //   return alert(Constants.NMLS_NUMBER_TYPE);
    // }
    // if (signUpBody.emailId === "") {
    //   return alert(EMAIL_REQUIRED);
    // }
    // if (!utility.validEmail(signUpBody.emailId)) {
    //   return alert(INVALID_EMAIL);
    // }
    // if (signUpBody.password === "") {
    //   return alert(PASSWORD_REQUIRED);
    // }
  }

  handleChange = (key, errorField) => (value) => {
    const { values, errors } = this.state;
    const resetErrors = {
      ...errors,
      [errorField]: '',
    };
    if (key === 'fullName') {
      const nameRegex = /^[a-z .']+$/i;
      if (nameRegex.test(value) || value === '') {
        values[key] = value;
        this.setState({ values, errors: resetErrors });
      }
    } else if (key === 'nmlsNumber') {
      if (utility.validNumber(value) || value === '') {
        values[key] = value;
        this.setState({ values, errors: resetErrors });
      }
    } else {
      values[key] = value;
      this.setState({ values, errors: resetErrors });
    }
  };

  handleChecked = (e) => {
    this.setState({
      checked: e.target.checked,
      checkedError: e.target.checked ? '' : TERMS_CONDITIONS,
    });
  };

  render() {
    const {
      fullName,
      nmlsNumber,
      emailId,
      password,
      checked,
    } = this.state.values;

    const {
      fullNameError,
      companyNameError,
      nmlsNumberError,
      emailIdError,
      passwordError,
    } = this.state.errors;

    // const { companyId, companyList, signupProcessing, showLogin } = this.state;
    const errorStyle = { color: 'red', fontSize: 12, marginTop: '5px' };
    return (
      <div className='signup_login_form d-flex'>
        <TutorialSlider/>
        <div className='form-content'>
          <div className='not_member'>
            {'Already a member?'}
            <TouchableOpacity onPress={() => this.props.history.push(ROUTE_CONSTANTS.LOGIN)}>
              <span>{'Sign In'}</span>
            </TouchableOpacity>
          </div>

          <div className='form-fieldset'>
            <h4>{SIGNUPTO}</h4>

            <div className='form-contain'>
              <div className='form-fields'>
                <div className='row'>
                  <div className='col6'>
                    <label>{'Full Name*'}</label>
                    <div className='form-group'>
                      <TextInput
                        style={styles.textInput}
                        value={fullName}
                        placeholder={'E.g. Adrian Coronian'}
                        maxLength={30}
                        autoFocus={true}
                        placeholderTextColor={GREY_COLOR}
                        autoCorrect={false}
                        onChangeText={this.handleChange(
                          'fullName',
                          'fullNameError',
                        )}
                        underlineColorAndroid='transparent'
                        autoCapitalize='none'
                      />
                      <p style={errorStyle}>{fullNameError}</p>
                    </div>
                  </div>
                  <div className='col6'>
                    <label>{'Company*'}</label>
                    <div className='form-group'>
                      <DropDown
                        data={this.props.companiesList}
                        callback={(id) => {
                          this.setCompanyId(id);
                        }}
                      />
                      <p style={errorStyle}>{companyNameError}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='form-fields'>
                <div className='row'>
                  <div className='col6'>
                    <label>{'NMLS*'}</label>
                    <div className='form-group'>
                      <TextInput
                        style={styles.textInput}
                        value={nmlsNumber}
                        placeholder={'NMLS'}
                        placeholderTextColor={GREY_COLOR}
                        autoCorrect={false}
                        autoCapitalize='none'
                        onChangeText={this.handleChange(
                          'nmlsNumber',
                          'nmlsNumberError',
                        )}
                        onSubmitEditing={() => this.emailRef.current.focus()}
                        underlineColorAndroid='transparent'
                      />
                      <p style={errorStyle}>{nmlsNumberError}</p>
                    </div>
                  </div>
                  <div className='col6'>
                    <label>{'Email Address*'}</label>
                    <div className='form-group'>
                      <TextInput
                        style={styles.textInput}
                        value={emailId}
                        placeholder={'E.g. adrian@gmail.com'}
                        placeholderTextColor={GREY_COLOR}
                        keyboardType='email-address'
                        autoCorrect={false}
                        autoCapitalize='none'
                        ref={this.emailRef}
                        onChangeText={this.handleChange(
                          'emailId',
                          'emailIdError',
                        )}
                        onSubmitEditing={() => this.passwordRef.current.focus()}
                        underlineColorAndroid='transparent'
                      />
                      <p style={errorStyle}>{emailIdError}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='form-fields'>
                <div className='row'>
                  <div className='col6'>
                    <label>{'Password*'}</label>
                    <div className='form-group'>
                      <TextInput
                        value={password}
                        ref={this.passwordRef}
                        style={styles.textInput}
                        placeholder={'***********'}
                        placeholderTextColor='rgb(138, 138, 138)'
                        returnKeyType={GO}
                        secureTextEntry
                        autoCorrect={false}
                        onSubmitEditing={() => {
                          this.onPressSignupBtn();
                        }}
                        onChangeText={this.handleChange(
                          'password',
                          'passwordError',
                        )}
                        underlineColorAndroid='transparent'
                      />
                      <p style={errorStyle}>{passwordError}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='form-fields'>
                <div className='row'>
                  <div className='col12'>
                    <Checkbox
                      onChange={this.handleChecked}
                      checked={checked}
                      color='default'
                    />
                    <Text>
                      {'I agree to the '}
                      <TouchableOpacity
                        onPress={() =>
                          window.open(ROUTE_CONSTANTS.TERMS_OF_USE, '_blank')
                        }
                      >
                        <Text
                          style={{ color: PRIMARY_COLOR, fontWeight: 'bold' }}
                        >
                          {'Terms of Use'}
                        </Text>
                      </TouchableOpacity>
                    </Text>
                  </div>
                  <p style={{ ...errorStyle, marginLeft: 15 }}>
                    {this.state.checkedError}
                  </p>
                </div>
              </div>

              <div className='btn-half row'>
                <div className='col6'>
                  <Button
                    bgColor={SECONDARY_DARK_COLOR}
                    title={SIGN_UP}
                    signIn={() => {
                      this.onPressSignupBtn();
                    }}
                    titleColor={'white'}
                  />
                </div>
              </div>
            </div>
          </div>

          <LoadingModal isVisible={this.props.loading}/>
        </div>
      </div>
    );
  }
}

export default withRouter(withSnackbar(SingUpScreen));
